import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ModalCloserService} from "../../modal-closer.service";
import {AppointmentsService} from "../../Services/appointments/appointments.service";
import {CookieService} from 'angular2-cookie/services/cookies.service';

@Component({
  selector: 'app-desktop-cancel-demo',
  templateUrl: './desktop-cancel-demo.component.html',
  styleUrls: ['./desktop-cancel-demo.component.scss']
})
export class DesktopCancelDemoComponent implements OnInit {

  @Output() close = new EventEmitter();

  modalCloser: ModalCloserService;
  appointmentService: AppointmentsService;

  constructor(modalCloser: ModalCloserService, appointmentService: AppointmentsService) {
    this.modalCloser = modalCloser;
    this.appointmentService = appointmentService;
  }

  ngOnInit() {
  }

  cancel() {
    window['appointmentID'] = CookieService.prototype.get('appointmentID');
    document.getElementById('loader').classList.add('show');
    this.appointmentService.cancelDemo().subscribe();
    document.getElementById('close-modal').click();
  }

  reschedule() {
    if ( window['appointmentID'] !== 0 ) {
      document.getElementById('loader').classList.add('show');
      this.appointmentService.cancelDemo(true).subscribe();
    } else {
      alert('You do not have an appointment yet.');
    }
    document.getElementById('close-modal').click();
  }

  closeModal() {
    document.getElementById('close-modal').click();
  }
}



// WEBPACK FOOTER //
// /app/src/app/Components/desktop-cancel-demo/desktop-cancel-demo.component.ts